<template>

    <div v-if="races.length > 0">
        
        <div id="race-selector" class=''>
            <div class="race-name"> <div>{{ currentRaceName }}</div> </div>
            <i class='fa fa-caret-down'></i>
        </div>

        <b-popover :show.sync="show" ref="pop" triggers="click" placement="bottom-end"  target="race-selector" >
             
             <menu-item @click="()=>seleceCurrentRace(index)" v-for="(race, index) in races" >{{race.name}}</menu-item>
                <!-- <div> 
                    <b-dropdown-item @click="()=>seleceCurrentRace(index)" v-for="(race, index) in races" :active="race.name==currentRaceName" >{{race.name}}</b-dropdown-item>
                </div> -->
        </b-popover>


    </div>

</template>



<script>
export default {
     data() {
      return {
        show: false
      }
    },
    computed:{
        races:function(){
            return this.$store.getters.races;
        },
        currentRaceName:function(){
            return this.$store.getters.currentRaceName;
        }
    },

    methods:{
        seleceCurrentRace:function(index){
            // this.$store.commit('setPercursoState',{actualRace:index});
            // this.$store.commit('actualCourseLeg',0);

            this.$router.push({ params: { id: 0, race: index } });
            this.show = false
        },
    }


}
</script>

<style lang="stylus" >

    // @import "../css/variaveis";

    #race-selector{
        width: 100%;
        border-bottom:1px dotted white;
        cursor: pointer;
        line-height: 0.9;
        display: flex;
        padding-bottom:0.4em;
        margin-bottom: 1em;
        .race-name{
            flex-grow: 1;
            div{
                max-width 200px;
            }
        }
        i{
             align-self:
        }
    }
</style>
